import styled from 'styled-components';
import { color } from 'styles/settings';

export const Container = styled.div`
  background-color: ${color.neutral.grayLighter};
  width: 0vw;
  /* height: 100vh; */
`;
